<block-ui></block-ui>
<div class="container-fluid">
  <div class="card card-custom-h">
    <div class="card-body accordion-custom">
      <ngb-accordion #acc="ngbAccordion" activeIds="ngb-panel-0" *ngFor="let Item of HelpCenterItems;let itemIndex=index;">
        <ngb-panel>
          <ng-template ngbPanelTitle>
            <h4 id="parentTitle" *ngIf="language=='en'">{{Item.title.english}}</h4>
            <h4 id="parentTitle" *ngIf="language=='ar'">{{Item.title.arabic}}</h4>
            <div id="parentdesc" *ngIf="language=='en'" class="text-muted">{{Item.description.english}}</div>
            <div id="parentdesc" *ngIf="language=='ar'" class="text-muted">{{Item.description.arabic}}</div>
          </ng-template>
          <ng-template ngbPanelContent>
            <ul id="{{'Lvl1-'+Item.id}}">
              <li  *ngFor="let child of Item.children;let i=index;">
                <a [ngClass]="{'active helpcenterlink': i === 0}" ( data-toggle="tab" role="tab" aria-selected="true" href="{{'#Content-'+i+'-'+itemIndex}}">
                  <span class="kt-nav__link-text text-to-truncate1" *ngIf="language=='en'">{{child.title.english}}</span>
                  <span class="kt-nav__link-text text-to-truncate1" *ngIf="language=='ar'">{{child.title.arabic}}</span>
                </a>
              </li>
            </ul>
            <div *ngFor="let child of Item.children;let i=index;" class="d-flex align-items-center bg-light-dark rounded p-5 mb-7">
              <div id="{{'#Content-'+i+'-'+itemIndex}}">
                <div  *ngFor="let lastChild of child.children;let j=index;">
                      <span *ngIf="language=='en'" class="fw-bolder text-light fs-4 mb-2">{{lastChild.title.english}}</span>
                      <span *ngIf="language=='ar'" class="fw-bolder text-light fs-4 mb-2">{{lastChild.title.arabic}}</span>
                  <div>
                      <div>
                        <span *ngIf="language=='en'" class="text-primary fw-bold d-block" innerHtml="{{lastChild.html.english}}">
                        </span>
                        <span *ngIf="language=='ar'" class="text-primary fw-bold d-block" innerHtml="{{lastChild.html.arabic}}">
                        </span>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </ngb-panel>
      </ngb-accordion>
    </div>
  </div>
</div>

